module.exports = __webpack_public_path__ + "img/location-3-active.b375609f.png";